import { Button } from "@/components/ui/button";
import RightSideSheet from "@/components/ui/others/RightSideSheet";
import { useAppDispatch, useAppSelector } from "@/stores/hook";
import Actions from "./components/Actions";
import { CourseFormProvider } from "../../contexts/FormCourseContext";
import { setIsAddCourse } from "../../stores/courseFunctionalSlice";
import CourseBasics from "./components/CourseBasics/courseBasics";
import CourseFeesIntakes from "./components/FeesIntakes/courseFeesIntakes";
import CourseAdmissionRequirements from "./components/AdmissionRequirements/CourseAdmissionRequirements";
import CourseBrochure from "./components/CourseBrochure/courseBrouchure";
import CoursePrefrenceRenderer from "./components/coursePrefrences/CoursePrefrenceRenderer";
import RevenueCommissions from "./components/RevenueCommissions/RevenueCommissions";

interface AddCourseProps {
  /**
   * Custom opener. The sheet is the same one the University & Course page
   * uses; the lead drawer's Course tab passes a compact pill here (see
   * `module/education/nicheSideRoutes/Course/Course.tsx`). Open/close still
   * rides the shared `courseFunctional.isAddCourse` flag so the form's own
   * Cancel / Save close it.
   */
  trigger?: React.ReactNode;
}

export default function AddCourse({ trigger }: AddCourseProps = {}) {
  const { isAddCourse } = useAppSelector((state) => state.courseFunctional);
  const dispatch = useAppDispatch();

  return (
    <CourseFormProvider>
      <RightSideSheet
        width="40vw"
        open={isAddCourse}
        handleClose={() => dispatch(setIsAddCourse(false))}
        title="Add Course"
        description="Create a course by filling the required details"
        trigger={
          trigger ?? (
            <Button
              onClick={() => dispatch(setIsAddCourse(true))}
              variant="primary"
            >
              + Add Course
            </Button>
          )
        }
        actions={<Actions />}
      >
        <form onSubmit={(e) => e.preventDefault()} className="w-full p-4">
          <div className="flex flex-col gap-4">
            <CourseBasics />
            <CourseFeesIntakes />
            <RevenueCommissions />
            <CoursePrefrenceRenderer />
            <CourseAdmissionRequirements />
            <CourseBrochure />
          </div>
        </form>
      </RightSideSheet>
    </CourseFormProvider>
  );
}
